import shopInfos from './infos'
import type { LandingPageAboutPageSettings } from 'src/shared/dbTypes/landingPageSettings'

// Content belongs exclusively to this shop, never to shared defaults.
const heroImage = '/api/images/landingpages/204/sebastian-reither-moebel-zeppenfeld-1777528654207.png'
const showroomImage = '/api/images/landingpages/204/aera-sofa-belisa-violetta-sitzkomfort-moebel-zeppenfeld-olpe-1777469799594.webp'

const getShopInfoText = (key: string, fallback: string) => {
  const value = (shopInfos as Record<string, unknown>)[key]
  return typeof value === 'string' || typeof value === 'number'
    ? String(value)
    : fallback
}

const aboutPage: LandingPageAboutPageSettings = {
  enabled: true,
  metaTitle: `Über uns | ${shopInfos.name} by Möbel Zeppenfeld`,
  metaDescription: 'Erfahren Sie mehr über designmoebelkaufen.de, Möbel Zeppenfeld in Olpe und persönliche Beratung für hochwertige Designmöbel.',
  heroEyebrow: 'Designmoebelkaufen by Möbel Zeppenfeld',
  heroTitle: 'Designmöbel online entdecken. Persönlich beraten in Olpe.',
  heroBody: 'Seit 1937 steht Möbel Zeppenfeld für hochwertige Einrichtung, ehrliche Beratung und Wohnräume, die zu Menschen passen.',
  heroImageSrc: heroImage,
  heroImageAlt: 'Möbel Zeppenfeld Beratung und Einrichtung in Olpe',
  heroMobileImageSrc: '',
  heroMobileImageAlt: '',
  heroCta: {
    label: 'Beratung anfragen',
    href: '',
    action: 'contactModal',
    contactSubject: 'termin',
  },
  heroSecondaryCta: {
    label: 'Bewertungen ansehen',
    href: getShopInfoText('googleReviewHref', 'https://www.google.com/search?q=M%C3%B6bel+Zeppenfeld+Olpe+Bewertungen'),
  },
  introTitle: 'Ein Möbelhaus mit Haltung',
  introBodyHtml: '<p>designmoebelkaufen.de ist der Onlineshop von Möbel Zeppenfeld aus Olpe. Wir verbinden ausgewählte Designmarken mit der Erfahrung eines gewachsenen Familienunternehmens.</p>',
  stats: [
    {
      value: '1937',
      label: 'gegründet als Handwerksbetrieb mit Blick für Qualität.',
    },
    {
      value: getShopInfoText('googleRating', '4,8'),
      label: 'Google-Bewertung für persönliche Beratung und Service.',
    },
    {
      value: 'Olpe',
      label: 'Showroom, Beratung und Wohnkompetenz im Sauerland.',
    },
  ],
  featureTitle: '',
  featureSubtitle: '',
  features: [
    {
      title: 'Kuratierte Auswahl',
      body: 'Wir nehmen nicht jedes Möbel auf. Entscheidend sind Material, Verarbeitung, Komfort, Design und die Frage, ob ein Produkt langfristig Freude macht.',
    },
    {
      title: 'Persönliche Beratung',
      body: 'Bei Fragen zu Maßen, Materialien, Farben oder Kombinationen sprechen Sie mit Menschen, die Einrichtung täglich planen und begleiten.',
    },
    {
      title: 'Online und vor Ort',
      body: 'Viele Designs können Sie online entdecken. Für Materialien, Sitzkomfort und Raumwirkung laden wir Sie zusätzlich in unsere Ausstellung ein.',
    },
  ],
  storyTitle: 'Design live erleben',
  storyBodyHtml: [
    '<p>In unserer Ausstellung erleben Sie Materialien, Proportionen und Sitzkomfort direkt. So entstehen Entscheidungen, die nicht nur im Warenkorb gut aussehen, sondern im eigenen Zuhause funktionieren.</p>',
    '<p>Unser Team begleitet Sie von der ersten Inspiration bis zur passenden Lösung für Wohnbereich, Esszimmer, Schlafzimmer oder individuelle Stauraumplanung.</p>',
  ].join(' '),
  storyImageSrc: showroomImage,
  storyImageAlt: 'Wohnambiente und Beratung bei Möbel Zeppenfeld in Olpe',
  contactTitle: 'Sie planen ein neues Möbelstück oder einen ganzen Raum?',
  contactBody: 'Wir beraten telefonisch, per E-Mail oder persönlich in Olpe.',
  contactCta: {
    label: 'Kontakt aufnehmen',
    href: '/kontakt',
  },
}

export default aboutPage

